/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagesplanDto } from '../../models/tagesplan-dto';

export interface GetTagesplaene$Json$Params {
  onlySoftDeletes?: boolean;
}

export function getTagesplaene$Json(http: HttpClient, rootUrl: string, params?: GetTagesplaene$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagesplanDto>>> {
  const rb = new RequestBuilder(rootUrl, getTagesplaene$Json.PATH, 'get');
  if (params) {
    rb.query('onlySoftDeletes', params.onlySoftDeletes, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TagesplanDto>>;
    })
  );
}

getTagesplaene$Json.PATH = '/v1/tagesplaene';
